export default __webpack_public_path__ + "static/media/Boton_3.80d64aa9.png";